import { graphql } from "gql";

const ADMIN_CREATE_USER_ATTRIBUTE_MUTATION = graphql(`
  mutation AdminCreateUserAttribute($input: AdminCreateUserAttributeInput!) {
    adminCreateUserAttribute(input: $input) {
      ...UserAttribute
    }
  }
`);

export default ADMIN_CREATE_USER_ATTRIBUTE_MUTATION;
